import HeaderMain from "../comp/head-navs-main";
import ViewContent from "../comp/view-content";
import ViewDividerSmall from "../comp/view-divider-sm";
import ViewDividerMedium from "../comp/view-divider-md";
import ViewSectionName from "../comp/view-section-name";

import TeamListModule from "../comp/team-list";

export default function TeamList() {


  return (
    <>
      <HeaderMain />
      <ViewContent 
        content={
          <>  
            <ViewSectionName data={'My Students'}/>
            <TeamListModule />

            <ViewDividerMedium />
            <ViewDividerMedium />
          </>
        }
      />
      

    </>
  )
}